import React from 'react';
import DatePicker from 'react-mobile-datepicker';
import DatePickerStyleInjector from './DatePickerStyleInjector';
import { View } from 'react-native';

interface CustomDatePickerProps {
  value: Date;
  isOpen: boolean; // Controlled by the parent
  onSelect: (date: Date) => void;
  onCancel: () => void;
  customHeader?: string;
  theme?: 'default' | 'dark' | 'ios' | 'android' | 'android-dark';
  minDate?: Date;
  maxDate?: Date;
}

const monthMap: Record<number, string> = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  value,
  isOpen,
  onSelect,
  onCancel,
  customHeader = 'Business Start Date',
  theme = 'default',
  minDate = new Date(1940, 0, 1), // Default to Jan 1, 1970
  maxDate = new Date(), // Default to today
}) => {
  const config = {
    month: {
      format: (value: Date) => monthMap[value.getMonth() + 1],
      caption: 'Mon',
      step: 1,
    },
    date: {
      format: 'D',
      caption: 'Day',
      step: 1,
    },
    year: {
      format: 'YYYY',
      caption: 'Year',
      step: 1,
    },
  };

  return (
    <View>
      <DatePickerStyleInjector />
      <DatePicker
        value={value}
        isOpen={isOpen}
        onSelect={onSelect}
        onCancel={onCancel}
        theme={theme}
        confirmText="Confirm"
        cancelText="Cancel"
        dateConfig={config}
        customHeader={customHeader}
        min={minDate}
        max={maxDate}
      />
    </View>
  );
};

export default CustomDatePicker;
